module.exports = __webpack_public_path__ + "img/callbacklog.f6a6c172.png";